export default __webpack_public_path__ + "static/media/Day 2 - 14 Dec 2021.7f833a00.jpg";